export default __webpack_public_path__ + "static/media/forum_img_1.c82e5498.svg";